module.exports = __webpack_public_path__ + "img/PG4-1-952x398.bc040589.png";